import BoxImage from "@components/BoxImage";
import ButtonContainer from "@components/ButtonContainer";
import { ReactElement } from "react";
import { Col } from "reactstrap";
import TPartnerDto from "types/Partner/partnerDto";
import styles from "./DetailForm.module.scss";

interface IDetailForm {
  data: TPartnerDto;
}

const DetailForm = ({ data }: IDetailForm): ReactElement => (
  <form className="form">
    <Col md={6}>
      <div className="form__form-group">
        <span className="form__form-group-label">Name</span>
        <div className="form__form-group-field">
          <input type="text" value={data?.name} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Description</span>
        <div className="form__form-group-field">
          <textarea value={data?.description} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Order</span>
        <div className="form__form-group-field">
          <input type="text" value={data?.order} disabled />
        </div>
      </div>
      {data?.heroImageUrl && (
        <BoxImage title="Hero" urlImage={data?.heroImageUrl} />
      )}
    </Col>

    <Col md={6}>
      <BoxImage title="Logo" urlImage={data?.imageUrl} />

      <div className="form__form-group">
        <span className="form__form-group-label">Artists</span>
        <div className="form__form-group-field">
          <div className={styles.artists}>
            {data?.artists?.map((artist) => (
              <div className={styles.artist}>
                <span>{artist.displayName}</span>
                <span>{artist.walletAddress}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Col>
    <ButtonContainer />
  </form>
);

export default DetailForm;
